import React, { useEffect, useRef } from "react";
import Hls from "hls.js";

const VideoPlayer = ({ videoUrl, onClose }) => {
  const videoRef = useRef(null);

  useEffect(() => {
    const video = videoRef.current;
    let hls;

    // Attach video player
    if (Hls.isSupported()) {
      hls = new Hls({
        autoStartLoad: true,
        enableWorker: false, // Important for older Tizen browsers
        debug: false,
      });
      hls.loadSource(videoUrl);
      hls.attachMedia(video);
    } else if (video.canPlayType("application/vnd.apple.mpegurl")) {
      video.src = videoUrl;
    } else {
      console.error("HLS not supported in this environment.");
    }

    // Ensure autoplay after attach
    const tryPlay = () => {
      video
        .play()
        .then(() => {
          console.log("Playback started");
        })
        .catch((err) => {
          console.warn("AutoPlay failed:", err);
        });
    };

    // Delay play to ensure proper binding
    setTimeout(() => tryPlay(), 300);

    // Handle BACK/ESC key
    const handleKeyDown = (e) => {
      const key = e.keyCode;
      if (key === 10009 || key === 27) {
        // BACK or ESC
        e.preventDefault();
        cleanup();
        onClose();
      }
    };

    const cleanup = () => {
      if (hls) {
        hls.destroy();
      }
      if (video) {
        video.pause();
        video.removeAttribute("src");
        video.load(); // force reloading
      }
      document.removeEventListener("keydown", handleKeyDown);
    };

    document.addEventListener("keydown", handleKeyDown);

    return cleanup;
  }, [videoUrl, onClose]);

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        backgroundColor: "#000",
        zIndex: 9999,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <video
        ref={videoRef}
        controls
        autoPlay
        playsInline
        preload="none"
        style={{
          width: "100%",
          height: "100%",
          objectFit: "contain",
          backgroundColor: "black", // Helps in rendering on Tizen
        }}
      />
      <p
        style={{
          position: "absolute",
          top: 10,
          right: 20,
          color: "#ccc",
          fontSize: "14px",
        }}
      >
        Press <strong>Back</strong> or <strong>Esc</strong> to exit
      </p>
    </div>
  );
};

export default VideoPlayer;
